// @flow
import type {
  AssetOperation,
} from '../types'

export default ({
  operations: [],
}: {
  operations: Array<AssetOperation>,
})
